/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { GenderEnum } from './genderEnum';
import { NullEnum } from './nullEnum';

/**
 * Child data
 */
export interface ChildrenGroup { 
    uuid: string;
    firstName: string;
    lastName: string;
    birthDate: string;
    gender?: GenderEnum | NullEnum;
    /**
     * Version of this entity (how many times it was changed)
     */
    readonly revision: number;
    age: number;
    resultAge: number;
}